export const baseURL = process.env.URL_BASE

export const passwordRules = {
   minimumLength: 12,
   requireLowercase: true,
   requireNumbers: true,
   requireSymbols: true,
   requireUppercase: true,
}
